import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DiscountFormDrawerSchema, DrawerMode } from '../types';
import { Discount } from 'entities/Discount';

const initialState: DiscountFormDrawerSchema = {
  discount: null,
  mode: null,
};

const discountFormDrawerSlice = createSlice({
  name: 'discountFormDrawer',
  initialState,
  reducers: {
    setOpenDiscountForm: (
      state: DiscountFormDrawerSchema,
      action: PayloadAction<{ mode: Nullable<DrawerMode>; discount?: Nullable<Discount> }>,
    ) => {
      state.mode = action.payload.mode;
      state.discount = action.payload.discount;
    },
  },
});

export const { actions: discountFormDrawerActions, reducer: discountFormDrawerReducer } = discountFormDrawerSlice;
